export const formatCurrency = (value) => {
  if (value === null || value === undefined || isNaN(value)) return "RM0.00";
  const num = parseFloat(value);
  return `RM${num.toLocaleString('en-MY', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = typeof dateStr === 'string' ? parseISODateString(dateStr) : dateStr;
  if (!date) return "";
  const day = date.getDate();
  const month = date.toLocaleString('en-US', { month: 'short' });
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
};

export const formatDateRange = (startDate, endDate) => {
  if (!startDate || !endDate) return "";
  const start = formatDate(startDate);
  const end = formatDate(endDate);
  if (start === end) return start;
  return `${start} – ${end}`;
};

export const calculateEventDays = (startDate, endDate) => {
  if (!startDate || !endDate) return 0;
  const start = parseISODateString(startDate);
  const end = parseISODateString(endDate);
  if (!start || !end) return 0;
  const diffTime = end.getTime() - start.getTime();
  const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24)) + 1;
  return diffDays > 0 ? diffDays : 0;
};

export const toISODateString = (date) => {
  if (!date) return "";
  if (typeof date === 'string') return date;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export function parseISODateString(dateStr) {
  if (!dateStr) return null;
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day);
}
